<div *ngIf="userProfileData">
    <div class="col-md-12 text-cente mt-5" *ngIf="userProfileData.business_verification_state == 'persona_verified'">
        <img src="assets/img/svg/other-details.svg" alt="" style="margin-top: 15px;">

        <h1>Business information Pending!</h1>

        <p>Please add your business information</p>
        <a href="javascript:void(0);" (click)="_persona.openPersonaAddBankModal()" mat-raised-button button class="b_11"
            style="color:'white'; margin-bottom: 189px;text-decoration: none;">Add Business information</a>

    </div>
    <div class="col-md-12 text-cente mt-5"
        *ngIf="userProfileData.business_verification_state == 'bank_added' || userProfileData.business_verification_state == 'persona_failed'">
        <img src="assets/img/svg/verify-persona-details.svg" alt="" style="margin-top: 15px;">

        <h1> Verification Pending!</h1>

        <p>Please verify your information</p>
        <a href="javascript:void(0);" (click)="_persona.openPersonaAddBankModal()" mat-raised-button button class="b_11"
            style="color:'white'; margin-bottom: 189px;text-decoration: none;">Verify Details</a>

    </div>
    <div class="col-md-12 text-cente mt-5"
        *ngIf="userProfileData.business_verification_state != 'persona_verified' && userProfileData.business_verification_state != 'bank_added' && userProfileData.business_verification_state != 'persona_failed'">
        <img src="assets/img/svg/add-bank.svg" alt="" style="margin-top: 15px;">

        <h1> {{userProfileData.auth_bank_status == 'verified' && userProfileData.business_verification_state === 'verification_pending' ? 'Please Verify Your Identity' : 
            userProfileData.auth_bank_status == 'verified' ? 'Bank Account added!' : 'No Account added yet!'}}</h1>
        <p>{{userProfileData.auth_bank_status == 'verified' && userProfileData.business_verification_state === 'verification_pending' ? 'Secure your account with identity verification' : userProfileData.auth_bank_status == 'verified' ? 'Please add more banking information' : 'Please add your
            bank account information'}}</p>
        <a href="javascript:void(0);" (click)="_persona.openPersonaAddBankModal()" mat-raised-button button class="b_11"
            style="color:'white'; margin-bottom: 189px;text-decoration: none; align-content: center;">
            {{userProfileData.business_verification_state === 'verification_pending' && userProfileData.auth_bank_status == 'verified' ? 'Verify Now' : userProfileData.auth_bank_status == 'verified' ? 'Add Details' : 'Add Bank'}}
        </a>

    </div>

</div>